<template>
    <div id="regBylink-container">
        <v-row class="px-2 pt-4">
            <v-col lg="6" md="6" sm="12" xs="12" offset-lg="3" offset-md="3" offset-sm="0" justify="center" class="pa-0">

                <v-overlay :value="loading">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>

                <v-col v-if="logo" align="center">
                    <v-img :src="require(`@/assets/${logo}`)" width="100"></v-img>
                </v-col>

                <!-- New Card -->
                <div>
                    <svg v-show="card.number.startsWith('4')" id="svg-visa" class="reg-form-svg" viewBox="0 0 100 44">
                        <text id="card-number" class="card-items" x="17.8" y="27" font-size="0.354em">{{ card.number }}</text>
                        <text id="card-holder" class="card-items" x="18" y="34" font-size="0.25em">{{ card.holder }}</text>
                        <text id="card-expiry" class="card-items" x="18" y="41" font-size="0.25em">{{ card.expiry }}</text>
                        <text id="card-cvv" class="card-items" x="75" y="34" font-size="0.25em">{{ card.cvv }}</text>
                    </svg>

                    <svg v-show="card.number.startsWith('5')" id="svg-mastercard" class="reg-form-svg" viewBox="0 0 100 44">
                        <text id="card-number" class="card-items" x="17.8" y="27" font-size="0.354em">{{ card.number }}</text>
                        <text id="card-holder" class="card-items" x="18" y="34" font-size="0.25em">{{ card.holder }}</text>
                        <text id="card-expiry" class="card-items" x="18" y="41" font-size="0.25em">{{ card.expiry }}</text>
                        <text id="card-cvv" class="card-items" x="75" y="34" font-size="0.25em">{{ card.cvv }}</text>
                    </svg>
                    
                    <svg v-show="(!('value' in exCard) || !exCard.value) && (!card.number || (!card.number.startsWith('4')) && !card.number.startsWith('5'))" id="svg-blank" class="reg-form-svg" viewBox="0 0 100 44">
                        <text v-if="'processed' in pbl && pbl.processed == 0" id="card-number" class="card-items" x="17.8" y="27" font-size="0.354em">{{ card.number }}</text>
                        <text v-else-if="'processed' in pbl && pbl.processed == 1" class="card-items" x="29" y="30" font-size="0.354em">Link Expired</text>
                        <text id="card-holder" class="card-items" x="18" y="34" font-size="0.25em">{{ card.holder }}</text>
                        <text id="card-expiry" class="card-items" x="18" y="41" font-size="0.25em">{{ card.expiry }}</text>
                        <text id="card-cvv" class="card-items" x="75" y="34" font-size="0.25em">{{ card.cvv }}</text>
                    </svg>
                </div>
                
                <!-- Existing Card -->
                <div v-if="!card.number && (exCard && 'value' in exCard && exCard.value)">
                    <svg v-show="exCard.cardData.bin.toString().startsWith('4')" id="svg-visa" class="reg-form-svg" viewBox="0 0 100 44">
                        <text id="card-number" class="card-items" x="17.8" y="27" font-size="0.354em" letter-spacing="0.68">{{ exCard.cardData.bin }}******{{ exCard.cardData.last4Digits }}</text>
                        <text id="card-holder" class="card-items" x="18" y="34" font-size="0.25em">{{ exCard.cardData.holder }}</text>
                        <text id="card-expiry" class="card-items" x="18" y="41" font-size="0.25em">{{ expiry }}</text>
                        <text id="card-cvv" class="card-items" x="75" y="34" font-size="0.25em">***</text>
                    </svg>
                    <svg v-show="exCard.cardData.bin.toString().startsWith('5')" id="svg-mastercard" class="reg-form-svg" viewBox="0 0 100 44">
                        <text id="card-number" class="card-items" x="17.8" y="27" font-size="0.354em" letter-spacing="0.68">{{ exCard.cardData.bin }}******{{ exCard.cardData.last4Digits }}</text>
                        <text id="card-holder" class="card-items" x="18" y="34" font-size="0.25em">{{ exCard.cardData.holder }}</text>
                        <text id="card-expiry" class="card-items" x="18" y="41" font-size="0.25em">{{ expiry}}</text>
                        <text id="card-cvv" class="card-items" x="75" y="34" font-size="0.25em">***</text>
                    </svg>
                </div>

                <v-col v-if="'processed' in pbl && pbl.processed != 1" md="12" class="reg-form-col">
                    <v-card class="reg-form-card">
                        <v-card-title class="px-3">Card Details</v-card-title>
                        <v-divider></v-divider>
                        <v-form ref="form" lazy-validation @submit="onSubmit">
                            <div class="px-4 py-2 pb-2">
                                
                                <!-- Card Selector -->
                                <v-row v-if="'scheduleId' in pbl">
                                    <v-col md="12" class="pt-6 pb-0">
                                        <v-select
                                            v-model="exCard"
                                            :items="activeCards"
                                            required
                                            dense
                                            label="Select Card"
                                            return-object
                                            @change="cardHandle"
                                        >
                                        </v-select>
                                    </v-col>
                                </v-row>

                                <!-- Existing Card -->
                                <v-col v-if="exCard && exCard.value" md="12" class="pb-0" align="center" justify="center">
                                    <v-img
                                        v-show="paymentBrand == 'visa'"
                                        src="@/assets/visa.png" width="200"
                                        transition="fade-transition"></v-img>
                                    <v-img 
                                        v-show="paymentBrand == 'master'"
                                        src="@/assets/mastercard-small.png"
                                        width="200"
                                        transition="fade-transition"></v-img>

                                    <div>
                                        <div class="mt-8"><b>Reference: </b>{{ card.merchantTransactionId }}</div>
                                        <div class="mt-2"><b>Card Number: </b>{{ `${exCard.cardData.bin}******${exCard.cardData.last4Digits}` }}</div>
                                        <div class="mt-2"><b>Card Holder: </b>{{ exCard.cardData.holder }}</div>
                                        <div class="mt-2"><b>Card Expiry: </b>{{ expiry }}</div>
                                        <div class="mt-2"><b>Add On: </b>{{ exCard.cardData.createdAt }}</div>
                                        <div class="mt-2 mb-2"><b>Amount: </b>{{ `${card.currency} ${card.amount}` }}</div>
                                    </div>
                                </v-col>

                                <!-- New Card -->
                                <div v-show="!('value' in exCard) || !exCard.value">
                                    <v-row>
                                        <!-- Reference -->
                                        <v-col md="12" class="py-0">
                                            <v-text-field
                                                v-model="card.merchantTransactionId"
                                                label="Reference"
                                                readonly
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <!-- Card Number -->
                                        <v-col md="12" class="py-0">
                                            <v-text-field
                                                v-model="card.number"
                                                label="Card Number"
                                                v-mask="masks.number"
                                                :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <!-- Card Holder -->
                                        <v-col md="12" class="py-0">
                                            <v-text-field
                                                v-model="card.holder"
                                                label="Card Holder"
                                                :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
            
                                    <v-row>
                                        <!-- Expiry -->
                                        <v-col md="6" class="py-0">
                                            <v-text-field
                                                v-model="card.expiry"
                                                label="Expiry"
                                                v-mask="masks.expiry"
                                                :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-col>

                                        <!-- CVV -->
                                        <v-col md="6" class="py-0">
                                            <v-text-field
                                                v-model="card.cvv"
                                                label="CVV"
                                                v-mask="masks.cvv"
                                                :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <!-- Address 1 -->
                                        <v-col md="12" class="py-0">
                                            <v-text-field
                                                v-model="card.address1"
                                                :rules="[rules.required]"
                                                label="1st Line Address"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <!-- Postcode -->
                                        <v-col md="12" class="py-0">
                                            <v-text-field
                                                v-model="card.postcode"
                                                label="Postcode"
                                                :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                            
                            <v-divider></v-divider>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    v-if="ifApple"
                                    @click="applePay"
                                    color="black"
                                    elevation="0"
                                    class="pa-2"
                                ><v-img src="@/assets/apple-pay.svg" width="1"></v-img></v-btn>
                                <v-btn
                                    v-if="(ifChrome && ifPaymentRequest)"
                                    @click="paymentRequest"
                                    outlined
                                    class="pa-2"
                                ><v-img src="@/assets/google-pay.svg" width="1"></v-img></v-btn>
                                <v-btn color="primary" type="submit">Pay Now</v-btn>
                            </v-card-actions>
                        </v-form>        
                    </v-card>

                    <v-row v-if="result && result.result.code == '000.000.000'" class="mt-4">
                        <v-col md="12" class="py-0">
                            <v-alert
                                type="success"
                                text border="left"
                                dismissible
                                class="mb-2">
                                Code: {{ result.result.code }}<br>
                                Description: {{ result.result.description }}
                            </v-alert>
                        </v-col>
                    </v-row>
                     <v-row v-if="result && result.result.code == '000.200.000'" class="mt-4">
                        <v-col md="12" class="py-0">
                            <v-alert
                                type="info"
                                text border="left"
                                dismissible
                                class="mb-2">
                                Code: {{ result.result.code }}<br>
                                Description: {{ result.result.description }}
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-row v-else-if="result && result.result.code != '000.000.000' && result.result.code != '000.200.000'" class="mt-4">
                        <v-col md="12" class="py-0">
                            <v-alert
                                type="error"
                                text border="left"
                                dismissible>
                                Code: {{ result.result.code }}<br>
                                Description: {{ result.result.description }}
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-col>

                <v-card v-if="!('value' in exCard) || !exCard.value" class="px-4 py-2 pb-0 elevation-0" color="#FAFAFA">
                    <iframe id="threeDsContainer" src="about:blank" frameBorder="0" scrolling="no"></iframe>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';

export default {
    directives: { mask },
    data() {
        return {
            pbl: { },
            card: {
                merchantTransactionId: null,
                number: '',
                amount: null,
                currency: null,
                holder: '',
                expiry: '',
                cvv: '',
                address1: null,
                postcode: null,
                channel: null
            },
            exCard: { value: null },
            exCards: [],
            currencies: [{ value: 'EUR', text: 'EUR' },
                         { value: 'GBP', text: 'GBP' }],
            masks: {
                number: '#### #### #### ####',
                expiry: '##/##',
                cvv: '###'
            },
            rules: {
                required: v => !!v || 'Required.',
            },
            result: null,
            loading: false,
            logo: null,
            payMethod: [{
                supportedMethods: 'basic-card',
                data: {
                    supportedNetworks: ['visa', 'mastercard'],
                    supportedTypes: ['credit', 'debit']
                }
            }],
            applePayMethod: {
                supportedMethods: "https://apple.com/apple-pay",
                data: {
                    version: 3,
                    merchantIdentifier: "merchant.totalcontrol",
                    merchantCapabilities: ["supports3DS", "supportsCredit", "supportsDebit"],
                    supportedNetworks: ["masterCard", "visa"],
                    countryCode: "GB",
                },
            },
            details: {
                total: {
                    label: 'Total',
                    amount: { currency: null, value: null }
                },
            },
            options: { requestShipping: false }
        }
    },
    computed: {
        activeCards() {
            let cards = [{ text:'Take a payment using a new card', value: null, cardData: null }];
            this.exCards.filter(e => {
                cards.push({ text: `${e.bin}******${e.last4Digits} - ${e.paymentBrand} - ${e.holder}`,
                             value: e.id,
                             cardData: e });
            });
            return cards;
        },
        paymentBrand() {
            return (this.exCard && this.exCard.value && this.exCard.cardData.bin.toString().startsWith(4)) ? 'visa' :
                   (this.exCard && this.exCard.value && this.exCard.cardData.bin.toString().startsWith(5)) ? 'master' : false
        },
        expiry() {
            return this.exCard.cardData.expMonth < 10 ?
                   `0${this.exCard.cardData.expMonth}/${this.exCard.cardData.expYear.toString().slice(-2)}` :
                   `${this.exCard.cardData.expMonth}/${this.exCard.cardData.expYear.toString().slice(-2)}`;
        },
        ifApple() {
            return window.ApplePaySession ? true : false;
        },
        ifPaymentRequest() {
            return window.PaymentRequest ? true : false;
        },
        ifChrome() {
            return navigator.userAgent.match('CriOS') || navigator.userAgent.match('Chrome') ? true : false;
        }
    },
    beforeMount() {
        this.clicked();
        this.getPayByLink();
    },
    methods: {
        onSubmit(e) {
            e ? e.preventDefault() : null;
            // New Card
            if(this.$refs.form.validate() || this.card.basicCard) {
                axios({
                method: 'post',
                url: `server-to-server-payment-live`,
                data: { card: this.card },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.transactionId = response.data.id;

                    if(response.data.result.code == '000.200.000') {
                        this.loading = true;
                        let iFrame = document.getElementById('threeDsContainer');
                        iFrame = iFrame.contentWindow || iFrame.contentDocument.document || iFrame.contentDocument;
                        iFrame.document.open();

                        let iframeData = '';
                        response.data.redirect.parameters.map(e => {
                            
                            iframeData += `<input type="text" name='${e.name}' value='${e.value}' />`;
                        });

                        const iframeForm = `<style type='text/css'>body { visibility: hidden; }</style><form method='post' action='${response.data.redirect.url}' id='3ds-form'>${iframeData}<input type="submit" id="submitForm"/></form>`;
                        iFrame.document.write(iframeForm);
                        iFrame.document.close();

                        iFrame = iFrame.document;
                        setTimeout(() => { 
                            iFrame.getElementById('3ds-form').submit(); 
                            setTimeout(() => { return this.getTransaction(); }, 15000);
                        }, 2000);
                    
                    }
                    else {
                        // this.loading = true;
                        // this.result = response.data;
                        // this.loading = false;

                        setTimeout(() => { return this.getTransaction(); }, 3000);
                    }
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            // Existing Card
            else {

                let payload = { 
                    card: this.exCard.cardData,
                    payment: { 
                        clientId: this.card.clientId,
                        scheduleId: this.card.scheduleId,
                        paymentId: this.card.paymentId,
                        amount: this.card.amount 
                    },
                    paymentType: 'PBL',
                    currency: this.card.currency,
                };

                axios({
                method: 'post',
                url: 'recurring-payment-live',
                data: payload,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.result = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        getTransaction() {
            axios({
            method: 'post',
            url: `get-transaction-live`,
            data: { uuid: this.transactionId,
                    channel: this.card.channel,
                    scheduleId: this.pbl.scheduleId,
                    paymentId: this.pbl.paymentId,
                    token: this.card.token },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.result = response.data;
                this.loading = false;

                return this.result;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getPayByLink() {
            axios({
                method: 'post',
                url: 'get-pay-by-link',
                data: { token: this.$route.params.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.card.token = response.data.hash;
                    this.card.merchantTransactionId = response.data.merchantTransactionId;
                    this.card.channel = response.data.channelUuid;
                    this.card.amount = response.data.amount;
                    this.card.currency = response.data.currency;
                    this.card.basicCard = 0;
                    this.logo = response.data.logo;
                    this.details.total.amount.value = response.data.amount;
                    this.details.total.amount.currency = response.data.currency;

                    if('scheduleId' in response.data) {
                        this.card.clientId = response.data.clientId;
                        this.card.scheduleId = response.data.scheduleId;
                        this.card.paymentId = response.data.paymentId;
                    }
                    this.pbl = response.data;
                    this.getCards();
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        getCards() {
            axios({
                method: 'post',
                url: 'get-active-cards',
                data: { clientId: this.card.clientId },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.exCards = response.data
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        cardHandle() {
            if(this.exCard.value) {
                this.exCard.cardData.scheduleId = this.pbl.scheduleId;
                this.exCard.cardData.paymentId = this.pbl.paymentId;
            }
            
            console.log(this.exCard);
        },
        clicked() {
            axios({
                method: 'post',
                url: 'pay-by-link-clicked',
                data: { token: this.$route.params.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {

                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        paymentRequest() {
            const request = new PaymentRequest(this.payMethod, this.details, this.options);

            request
            .show()
            .then(res => {
                this.card.number = res.details.cardNumber;
                this.card.cvv = res.details.cardSecurityCode;
                this.card.holder = res.details.cardholderName;
                this.card.expiry = `${res.details.expiryMonth}/${res.details.expiryYear.slice(-2)}`;
                this.card.address1 = res.details.billingAddress.addressLine[0];
                this.card.postcode = res.details.billingAddress.postalCode;
                this.card.basicCard = 1;
                this.onSubmit(false);
                res.complete('success');
            })
            .catch(err => {
                console.error('Something went wrong', err.message)
            })
        },
        async applePay() {
            try {
                const request = new PaymentRequest([this.applePayMethod], this.details, this.options);

                request.onmerchantvalidation = function (event) {
                    axios({
                    method: 'post',
                    url: 'applepay-validation',
                    data: { appleValidationUrl: event.validationURL,
                            appleMerchantId: 'merchant.totalcontrol',
                            displayName: 'Total Control'
                    },
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        console.log(response);
                        event.complete(response.data);
                    })
                    .catch(e => {
                        this.errors.push(e)
                    })
                };

                const response = await request.show();

                axios({
                method: 'post',
                url: 'applepay-payment',
                data: { token: response.details.token, card: this.card },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(res => {
                    console.log(res.data.result);
                    if(res.data.result.code == '000.000.000') {
                        this.result = res.data;
                        response.complete('success');
                    }
                    else {
                        this.result = res.data;
                        response.complete('failure');
                    }
                })
                .catch(e => {
                    this.errors.push(e)
                })
                
            } catch (e) {
                console.log(e);
            }
        }
    }
}
</script>

<style scoped>
    #regBylink-container {
        margin-left: -55px;
    }

    .card-items {
        font-family: 'Courier New', Courier, monospace;
        font-weight: 600;
        fill: #fff;
    }

    #svg-visa {
        background: url('../assets/tp-card-blank-visa.png') no-repeat;
        background-position: center;
        background-size: 70%;
    }

    #svg-mastercard {
        background: url('../assets/tp-card-blank-mastercard.png') no-repeat;
        background-position: center;
        background-size: 70%;
    }
    
    #svg-blank {
        background: url('../assets/tp-card-blank.png') no-repeat;
        background-position: center;
        background-size: 70%;
    }

    .reg-form-svg {
        z-index: 10;
        position: relative;
    }

    .reg-form-col {
        z-index: 0;
        position: relative;
        margin-top: -25%;

    }

    .reg-form-card {
        padding-top: 25% !important;
    }

    #threeDsContainer {
        display: block;
        background: #FAFAFA;
        border: none;
        height: 100vh;
        width: 100%;
    }

    #threeDsContainer body {
        color: #FAFAFA;
        font-size: 0px;
    }
</style>